<div class="c-randomPrizeInfo">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-randomPrizeInfo__container">
    <span class="text title">{{ 'home.live-ops.randomprize.modal-info.title' | translate }}</span>

    <div class="c-randomPrizeInfo__explanation">
      <div class="explanation">
        <div
          class="image"
          theming
          themingGroup="randomprize"
          themingAsset="step-one"
          [themingOverride]="randomPrize()?.assets"></div>
        @if (hasMinPurchase()) {
          <div class="min-purchase">
            <span class="text"
              >{{ 'home.live-ops.global.min-purchase' | translate }} {{ randomPrizeMinPurchase() }}
              {{ randomPrizeCurrencySymbol() }}</span
            >
          </div>
        }
        <span class="text subtitle">{{ 'home.live-ops.randomprize.modal-info.step-1' | translate }}</span>
      </div>

      <div
        class="arrow arrow-1"
        theming
        themingGroup="randomprize"
        themingAsset="arrow"
        [themingOverride]="randomPrize()?.assets"></div>

      <div class="explanation">
        <div
          class="image"
          theming
          themingGroup="randomprize"
          themingAsset="step-two"
          [themingOverride]="randomPrize()?.assets"></div>
        <span class="text subtitle">{{ 'home.live-ops.randomprize.modal-info.step-2' | translate }}</span>
      </div>

      <div
        class="arrow arrow-2"
        theming
        themingGroup="randomprize"
        themingAsset="arrow"
        [themingOverride]="randomPrize()?.assets"></div>

      <div class="explanation">
        <div
          class="image"
          theming
          themingGroup="randomprize"
          themingAsset="step-three"
          [themingOverride]="randomPrize()?.assets"></div>
        <span class="text subtitle">{{ 'home.live-ops.randomprize.modal-info.step-3' | translate }}</span>
      </div>
    </div>
  </div>
</div>
